export default "__VITE_ASSET__4741a392__"